import styled from "styled-components";


export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: transparent;
  font-size: 14px;
  .carousel{
    position: relative;
    width: 100%;

    .nav-arrow{
      position: absolute;
      top: 40px;
      transform: translateY(-50%);
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 0;
      border: none;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.85);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      opacity: 0.85;
      transition: all 0.2s ease-in-out;

      img{
        width: 16px;
        height: 16px;
        pointer-events: none;
      }

      svg{
        width: 20px;
        height: 20px;
        color: ${props => props.theme.colors.primary};
        pointer-events: none;
      }

      &:hover{
        opacity: 1;
        transform: translateY(-50%) scale(1.08);
      }
    }

    .nav-prev{
      left: 8px;
    }

    .nav-next{
      right: 8px;
    }
  }
  .categories{
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
    align-items: baseline;

    height: 100%;
    gap: 40px;
    padding: 0 56px;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar{
      display: none;
    }



    a{
      color: #000000;
      text-align: center;
      /* Paragraph 1 */
      font-family: "DM Sans", system-ui, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 26.5px; /* 165.625% */
      line-break: loose;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .category{
      width: 80px;
      height: 80px;
      flex-shrink: 0;
      background: transparent;
      border: 2px solid ${(props) => props.theme.colors.primary};
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 80px;
      overflow: hidden;

      img {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        object-fit: cover;
      }

    }
  }
  h2{
    font-family: var(--subtitle-h2-font-family);
    font-weight: var(--subtitle-h2-font-weight);
    color: var(--neutral-900);
    font-size: var(--subtitle-h2-font-size);
    letter-spacing: var(--subtitle-h2-letter-spacing);
    line-height: var(--subtitle-h2-line-height);
    font-style: var(--subtitle-h2-font-style);
    padding-bottom: 24px;
  }
  .products{
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    gap: 24px;
  }

  @media (max-width: 1440px){
    padding-left: 16px;
    padding-right: 16px;
  }
`;
